import { appSearchAdapter } from './adapters/app-search'
import type { SearchDataPort } from './domain/search'

const searchDataPort: SearchDataPort = appSearchAdapter

export { searchDataPort }
